"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performanceTimestampProvider = void 0;
exports.performanceTimestampProvider = {
  now: function () {
    return (exports.performanceTimestampProvider.delegate || performance).now();
  },
  delegate: undefined
};
